import { HostedCompute } from "~/components/job/Job/HostedCompute/HostedCompute";

export default HostedCompute;
